/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { useBreakpoint } from '@vlinder-web/breakpoint-hook-widget-react';
import Col from 'react-bootstrap/Col';

import * as S from './styles';

export interface IHeroImageProps {
  heroImage: {
    image?: string;
    title?: string;
    align?: 'center' | 'top';
  };
}

export const HeroImage = (props: IHeroProps) => {
  const { image, title, align } = props?.heroImage;
  const size = useBreakpoint();
  console.log('imggg->', image);
  return (
    <S.ImageCon src={image ?? `https://i.ibb.co/k6hxpL1p/image.png`}>
      <S.ImagesIcon
        src={image ?? `https://i.ibb.co/k6hxpL1p/image.png`}
      ></S.ImagesIcon>
    </S.ImageCon>
    // <S.ImgCol>
    //   <S.ProfileImage
    //     className='rounded-1'
    //     src={image ?? `https://ui-avatars.com/api/?name=${title}`}
    //     alt={title}
    //     // style={{
    //     //   marginBottom: size === 'xs' || size === 'sm' ? '20px' : '0px',
    //     // }}
    //     // rounded='lg'
    //   />
    // </S.ImgCol>
  );
};

HeroImage.defaultProps = {
  image: '',
  title: '',
};
